import { useState } from "react";
import { toast } from "sonner";
import { ArrowUp } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { requireAuth } from "@/lib/auth";

export const Priorities = ({ p, reload }) => {
  const [text, setText] = useState("");
  const run = (reason, fn) => requireAuth(reason, async () => {
    try { await fn(); await reload(); } catch (e) { toast(errMsg(e, "Something went wrong. Try again.")); }
  });
  const add = () => text.trim().length >= 2 && run("Suggest a priority", async () => { await api.post(`/properties/${p.propertyId}/priorities`, { text: text.trim() }); setText(""); });

  return (
    <section data-testid="priorities-section">
      <div className="eyebrow mb-4">What matters most here</div>
      <ol className="grid gap-2" data-testid="priorities-list">
        {p.priorities.map((x, i) => (
          <li key={x.id} className="flex items-center gap-3 border-b border-[var(--line)] py-3" data-testid={`priority-item-${i}`}>
            <span className="font-mono-ui w-6 text-xs text-[var(--stone-dark)]">{String(i + 1).padStart(2, "0")}</span>
            <span className="flex-1 text-sm">{x.text}<span className="block text-xs text-[var(--stone-dark)]">by {x.by}</span></span>
            <button disabled={x.voted} onClick={() => run("Upvote a priority", () => api.post(`/priorities/${x.id}/upvote`))} className={`inline-flex min-h-[40px] items-center gap-1 rounded-full border px-3 text-sm transition-colors ${x.voted ? "border-[var(--charcoal)] bg-[var(--charcoal)] text-[var(--bone)]" : "border-[var(--line)] hover:border-[var(--charcoal)]"}`} data-testid={`priority-upvote-${i}`}>
              <ArrowUp size={14} /> {x.votes}
            </button>
          </li>
        ))}
        {!p.priorities.length && <li className="text-sm text-[var(--stone-dark)]" data-testid="priorities-empty">No priorities yet. What should be fixed first?</li>}
      </ol>
      <div className="mt-4 flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Suggest a priority…" className="h-11 flex-1 rounded-xl border border-[var(--line)] bg-white/70 px-3 text-sm outline-none focus:border-[var(--charcoal)]" data-testid="priority-input" />
        <button className="btn-ghost" onClick={add} data-testid="priority-submit-button">Add</button>
      </div>
    </section>
  );
};
